import { IconButton } from "@mui/material";
import { useNavigate } from "react-router";
import IconArrowBackCircleOutline from "./img/IconArrowBackCircleOutline";
import { FC } from "react";

interface Props {
  route: string;
  color: string;
}

const BackButton: FC<Props> = ({ route, color }) => {
  const navigate = useNavigate();
  return (
    <IconButton
      onClick={() => navigate(route)}
      sx={{
        color,
        position: "absolute", // Coloca el icono en una posición absoluta dentro del contenedor
        top: {xs:4, md:16}, // Ajusta el espacio desde la parte superior
        left: {xs:4, md:16}, // Ajusta el espacio desde la parte izquierda
        fontSize: { xs: "1rem", sm:"1.5rem", md: "2rem" },
      }}
    >
      <IconArrowBackCircleOutline />
    </IconButton>
  );
};

export default BackButton;
